import { InspectionValues, StepTypes } from '@parallel-fluidics/shared/constants';

const NOTE_MAX = 60;

/**
 * The one-line description a collapsed traveler step shows under its
 * title — what you'd otherwise scroll up to check. Step type first, then
 * the facts that matter for that type (runs, thickness, installed bags,
 * report), then the inspection note, truncated. Pure, so the wording
 * lives in one place.
 */
export default function summarizeStep(step) {
  const parts = [step.type];
  if ([StepTypes.MOLDING, StepTypes.BONDING].includes(step.type)) {
    // Same label as the Run ID picker: "P072 - 3 - A".
    const runs = (step.runId || []).map(
      (run) => `${run.project} - ${run.runID}${run.cavity ? ` - ${run.cavity}` : ''}`,
    );
    parts.push(runs.length ? `Run ${runs.join(', ')}` : 'No run');
  }
  if (step.type === StepTypes.MOLDING && (step.minThickness || step.maxThickness)) {
    parts.push(`Thickness ${step.minThickness || '?'}–${step.maxThickness || '?'} mm`);
  }
  const bags = step.installedLots?.length || 0;
  if (bags) parts.push(`${bags} bag${bags === 1 ? '' : 's'} installed`);
  if (step.type === StepTypes.INSPECTION) {
    const reports = step.inspectionReport?.length || 0;
    parts.push(reports ? `${reports} report${reports === 1 ? '' : 's'}` : 'No report yet');
  }
  if (step.failureTags?.length) parts.push(step.failureTags.join(', '));
  const note = (step.inspectedNote || '').trim();
  if (note) {
    parts.push(`Note: ${note.length > NOTE_MAX ? `${note.slice(0, NOTE_MAX - 1)}…` : note}`);
  } else if (step.inspected === InspectionValues.PASSED) {
    parts.push('No note');
  }
  return parts.join(' · ');
}
